import React from "react";
import { formatDate } from "./common";
export default function Banner({ isPromotion, data, isSmall }) {
    return (React.createElement("div", { className: "rt-banner" },
        React.createElement("div", { className: "rt-promo-container" },
            isPromotion && React.createElement("div", { className: "rt-promo-label" }, "Promozione"),
            data.startDate && (React.createElement("div", { className: "rt-promo-label-data" },
                formatDate(data.startDate, data.startTime),
                " ",
                " - ",
                formatDate(data.endDate, data.endTime)))),
        React.createElement("a", { href: data.link },
            React.createElement("picture", { className: "rt-banner-img" },
                React.createElement("source", { srcSet: data.images.mobile + " 1x", media: "(max-width:767px)" }),
                React.createElement("source", { srcSet: data.images.tablet + " 1x", media: "(min-width: 768px) and (max-width: 1024px)" }),
                React.createElement("img", { src: isSmall ? data.images.tablet : data.images.desktop })))));
}
